import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} {...props}>
        <path
            fill="currentColor"
            d="M14 4C8.486 4 4 8.486 4 14s4.486 10 10 10 10-4.486 10-10S19.514 4 14 4m5 11H9v-2h10z"
        />
    </svg>
);
export default SvgMinus;
